import { Checkbox } from '@designsystem/stories/02-atoms/Checkbox';
import {
  Formfield,
  FormfieldProps,
} from '@designsystem/stories/03-molecules/Formfield';

export interface CheckboxProps extends FormfieldProps {
  /**
   * Whether the inserted value is invalid.
   */
  isInvalid?: boolean;
  /**
   * The ID of the input field.
   */
  id?: string;
  /**
   * The name of the checkbox.
   */
  name?: string;
  /**
   * The value of the checkbox.
   */
  value?: boolean;
  /**
   * Whether the input field is disabled.
   */
  isDisabled?: boolean;
  /**
   * The onChange handler.
   */
  onChange?: (checked: boolean) => void;
  /**
   * The onClick handler.
   */
  onClick?: () => void;
}

const CheckboxField = ({
  label,
  labelRequired,
  description,
  errorMessage,
  isRequired = false,
  isInvalid,
  isDisabled,
  value,
  children,
  ...props
}: CheckboxProps) => {
  return (
    <Formfield
      htmlFor={props?.id}
      description={description}
      isRequired={isRequired}
      labelRequired={labelRequired}
      errorMessage={errorMessage}
    >
      <Checkbox
        label={label}
        required={isRequired}
        disabled={isDisabled}
        error={isInvalid}
        checked={value}
        {...props}
      />
    </Formfield>
  );
};

export default CheckboxField;
